import header from './header';
import footer from './footer';

export default {
  loading: 'Loading messages...',
  empty: 'No messages',
  chat_not_select: 'Select a chat',

  no_more_message: 'No more message',

  status: {
    new: 'New',
    chat: 'Chat',
    resolved: 'Resolved',
  },

  message_email: {
    add: 'Save as contact\'s Email',
  },

  play_video: 'Play video',
  download_file: 'Download file',

  header,
  footer,
};
